import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'xp-empty-state',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './xp-empty-state.component.html',
	styleUrls: ['./xp-empty-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpEmptyStateComponent {
	icon = input<string | null>(null);
	imageSrc = input<string | null>(null);
	title = input<string | null>(null);
	description = input<string | null>(null);
}
